import{css as o}from"lit";var a=o`:host([_disabled]) .icon{--color:var(--cds-alias-status-disabled, var(--cds-global-color-construction-300, #aeb8bc))}`;export default a;
